export default __webpack_public_path__ + "static/media/historia.47859d6c.jpg";